export default "__VITE_ASSET__CLYx_OY1__"